import React, {Component} from 'react';
import './ProfileImages.css';
import OptionsButton from '../widgets/OptionsButton';
import {connect} from 'react-redux';
import Dropzone from 'react-dropzone';
import actions from './profile.actions';
import FancyButton from '../widgets/FancyButton';
import Icon from '../widgets/Icon';
import FancyInput from '../widgets/FancyInput';
import BioHelper from './BioHelper';
import {getYouTubeID} from './youtube';

const IMAGE_LIMIT = 6;

const {
	persistBackgroundImage,
	persistAvatarImage,
	persistProviderField,
	deleteImage,
	uploadProfileImage,
	profileDragOverProfileImage,
	profileDragOutProfileImage,
	moveImage
} = actions;

export class PresentationProfileImages extends Component {
	constructor() {
		super();

		this.state = {
			youTubeURL: ''
		};

		this.changeYouTubeURL = e => this.setState({youTubeURL: e.target.value});
		this.addYouTube = () => {
			if ((this.props.profile.profile.youtubeVideos || []).indexOf(this.state.youTubeURL) < 0) {
				this.props.setYouTubeVideos(
					[this.state.youTubeURL].concat(this.props.profile.profile.youtubeVideos || [])
				);
			}
			this.changeYouTubeURL({target: {value: ''}});
		};
		this.removeYouTubeVideo = ytId => {
			this.props.setYouTubeVideos(
				(this.props.profile.profile.youtubeVideos || []).filter(id => id !== ytId)
			);
		};
	}

	render() {
		if (!this.props || !this.props.profile || !this.props.profile.profile) {
			return null;
		}

		const {
			profile: {
				profile: {images, youtubeVideos},
				addingProfileImage,
				subscriptionLevel,
				user: {uuid: userUuid}
			},
			sessionProvider,
			editable,
			persistBackgroundImage,
			persistAvatarImage,
			deleteImage,
			dropProfileFile,
			dragOverAddImage,
			dragOutAddImage,
			draggingOverProfileImage,
			isAdmin,
			moveImage
		} = this.props;

		const isViewingOwn =
			userUuid === (sessionProvider && sessionProvider.user && sessionProvider.user.uuid);

		const imageCount = (images ? images.length : 0) + (youtubeVideos ? youtubeVideos.length : 0);

		return (
			<article
				className={`ProfileImages ${
					!addingProfileImage && (!images || !images.length) ? 'empty' : ''
				}`}>
				{editable && imageCount >= IMAGE_LIMIT ? (
					<p>
						<Icon name="warning" />
						<em>NOTE:</em> You have reached the profile limit of {IMAGE_LIMIT} media items
					</p>
				) : (
					undefined
				)}
				{editable && imageCount < IMAGE_LIMIT ? (
					<div className="ProfileImages-add">
						<Dropzone
							className={`ProfileImages-dropzone ${draggingOverProfileImage ? 'over' : ''} ${
								addingProfileImage ? 'adding' : ''
							}`}
							onDrop={dropProfileFile}
							accept="image/jpeg, image/png"
							onDragEnter={dragOverAddImage}
							onDragLeave={dragOutAddImage}
							disabled={!editable || !!addingProfileImage}>
							{!addingProfileImage && (
								<FancyButton>
									<span className="icon icon-add_a_photo" />
									<span className="ProfilePage-photos-label">Add photo</span>
									{isViewingOwn && subscriptionLevel !== 'none' ? (
										<BioHelper stepKey="images" />
									) : (
										undefined
									)}
								</FancyButton>
							)}
						</Dropzone>
						{['essentials', 'premium'].indexOf(subscriptionLevel) >= 0 ? (
							<div className="ProfileImages-youtube">
								<FancyInput
									placeholder="Paste YouTube video URL here (e.g. https://youtu.be/_QdPW8JrYzQ)"
									onChange={this.changeYouTubeURL}
									value={this.state.youTubeURL}
								/>
								{!addingProfileImage && (
									<FancyButton
										disabled={!this.state.youTubeURL || !this.state.youTubeURL.length}
										title="Paste a YouTube video URL to the left"
										onClick={this.addYouTube}>
										<span className="icon icon-personal_video" />
										<span className="ProfilePage-photos-label">Add YouTube video</span>
									</FancyButton>
								)}
							</div>
						) : (
							undefined
						)}
					</div>
				) : (
					undefined
				)}
				<ol>
					{/* Place holder for when there are no images */}
					{isViewingOwn && imageCount === 0 ? (
						<li key="placeholder" className="ProfileImages-placeholder">
							<p>Added photos will be shown here</p>
							<img src="/img/hands-up.jpg" alt="Added photos will be shown here" />
						</li>
					) : (
						undefined
					)}
					{!!addingProfileImage && (
						<li key="preview" style={{opacity: 0.5}}>
							<img src={`${addingProfileImage.preview}`} alt="" />
							<span
								style={{
									position: 'absolute',
									top: 0,
									bottom: 0,
									left: 0,
									right: 0,
									textAlign: 'center',
									lineHeight: '300px',
									fontSize: '200%',
									zIndex: 10
								}}>
								{Math.round(addingProfileImage.progress * 100)}%
							</span>
							{addingProfileImage && (
								<div
									style={{
										position: 'absolute',
										opacity: 0.5,
										background: 'white',
										bottom: 0,
										left: 0,
										right: 0,
										top: `${Math.round(addingProfileImage.progress * 100)}%`
									}}
								/>
							)}
						</li>
					)}

					{['essentials', 'premium'].indexOf(subscriptionLevel) >= 0 &&
						youtubeVideos &&
						youtubeVideos.map(ytId => (
							<li key={ytId} className="ProfileImages-youTubeVideo">
								{editable && (
									<OptionsButton
										className="ProfileImages-options"
										options={[
											// {key: 'header', icon: 'icon-photo', label: 'Set as header', onSelect: () => this.setYouTubeVideoHeader(ytId)},
											{
												key: 'delete',
												icon: 'icon-delete',
												label: 'Remove this video',
												onSelect: () => this.removeYouTubeVideo(ytId)
											}
										]}
									/>
								)}
								<iframe
									className={`ProfilePageHeader-media`}
									src={`https://www.youtube.com/embed/${getYouTubeID(
										ytId
									)}?rel=0&amp;controls=1&amp;showinfo=1`}
									frameborder="0"
									allow="encrypted-media"
									allowfullscreen="allowfullscreen"
									title="YouTube media"
								/>
							</li>
						))}
					{images &&
						images
							.sort((a, b) => b.priority - a.priority)
							.map((image, idx) =>
								image ? (
									<li key={image.image}>
										{editable && (
											<OptionsButton
												className="ProfileImages-options"
												options={[
													persistBackgroundImage
														? {
																key: 'header',
																icon: 'icon-photo',
																label: 'Set as header',
																onSelect: () => persistBackgroundImage(image.image)
														  }
														: undefined,
													persistAvatarImage
														? {
																key: 'use-as-avatar',
																icon: 'icon-person',
																label: 'Set as avatar',
																onSelect: () => persistAvatarImage(image.image)
														  }
														: undefined,
													{
														key: 'delete',
														icon: 'icon-delete',
														label: 'Remove this photo',
														onSelect: () => deleteImage(image.image)
													},
													idx !== 0
														? {
																key: 'forward',
																icon: 'icon-arrow_back',
																label: 'Move Forward',
																onSelect: () => moveImage(image.image, true)
														  }
														: undefined,
													idx < images.length - 1
														? {
																key: 'backward',
																icon: 'icon-arrow_forward',
																label: 'Move Backward',
																onSelect: () => moveImage(image.image, false)
														  }
														: undefined
												].filter(item => item && (isAdmin || item.key !== 'header'))}
											/>
										)}
										<img src={`/api/image/${image.image}`} alt="" />
									</li>
								) : (
									undefined
								)
							)}
				</ol>
			</article>
		);
	}
}

const ConnectedProfileImages = connect(
	({profile, session}) => ({
		profile,
		sessionProvider: session && session.current,
		editable:
			session.current &&
			session.current.user &&
			profile &&
			(session.current.user.admin || session.current.provider.uuid === profile.uuid),
		isAdmin: session.current && session.current.user && profile && session.current.user.admin
	}),
	dispatch => ({
		setYouTubeVideos: youtubeVideos => dispatch(persistProviderField({profile: {youtubeVideos}})),
		persistBackgroundImage: value => dispatch(persistBackgroundImage(value)),
		persistAvatarImage: value => dispatch(persistAvatarImage(value)),
		deleteImage: value => dispatch(deleteImage(value)),
		dropProfileFile: acceptedFiles =>
			acceptedFiles[0] && dispatch(uploadProfileImage(acceptedFiles[0])),
		dragOverAddImage: () => dispatch(profileDragOverProfileImage()),
		dragOutAddImage: () => dispatch(profileDragOutProfileImage()),
		moveImage: (image, forward) => dispatch(moveImage(image, forward))
	})
)(PresentationProfileImages);

export default ConnectedProfileImages;



// WEBPACK FOOTER //
// ./src/profile/ProfileImages.js